import Contacts from "./components/Contacts";

function App() {
  return (
    <div className="container">
      <header>
        <h1>Meet the Team</h1>
      </header>
      <main>
        <Contacts />
      </main>
    </div>
  );
}

export default App;
